






import { Component } from "vue-property-decorator";
import OverviewMixin from "@/mixins/admin/overviewMixin";

@Component({
  components: {
    "transactions-listing": () =>
      import("@/components/app/admin/transactions/transactionsListing.vue"),
    "transactions-provider": () =>
      import("@/components/app/admin/transactions/transactionsProvider.vue")
  }
})
export default class AdminTransactionsOverview extends OverviewMixin {
  public get contentAvailable() {
    return this.$userCan(`list_payment_logs`);
  }
  // Override OverviewMixin
  public get tableId() {
    return "TT1";
  }
  // Override OverviewMixin
  public get defaultLabel(): string {
    return this.$t("_.transactions") as string;
  }
}
